import React from 'react'
import PropTypes from 'prop-types'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import oeqActions from 'redux/actions/oeqActions'
import { localize } from 'helpers/translator'

const OEQCancelConfirm = props => (
	<Confirm
		btOne={localize('global_no')}
		btTwo={localize('global_yes')}
		alertMessage={localize('oeq_cancelConfirm')}
		actionButtonType={0}
		actionOne={props.actions.cancelReject}
		actionTwo={props.actions.cancelConfirm}
		closeAction={props.actions.cancelReject}
	/>
)

OEQCancelConfirm.defaultProps = {
	actions: {
		cancelReject: () => {},
		cancelConfirm: () => {},
	},
}

OEQCancelConfirm.propTypes = {
	actions: PropTypes.object,
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		cancelReject: oeqActions.cancelReject,
		cancelConfirm: oeqActions.cancelOEQConfirmed,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(OEQCancelConfirm)

export { OEQCancelConfirm }
